export const IMAGE_ALIGN_RIGHT = "right";

export const IMAGE_ALIGN_LEFT  = "left";

export const BASE_URL = "https://capitaltrends.in";
// export const BASE_URL = "http://localhost:4100";
// export const BASE_URL = "http://beta.capitaltrends.in:4101";

export const GHOST_POSTS_GET_URL = "https://trading.capitaltrends.in/ghost/api/content/posts/?key=829df655924dd222b3614ab700";

export const GHOST_PAGES_GET_URL = "https://trading.capitaltrends.in/ghost/api/content/pages/?key=829df655924dd222b3614ab700";

export const MARKET_DASHBOARD_COMPONENTS = [
    { key:1, value: 'Sectoral Indices', label: 'Nifty Sectors' },
    { key:2, value: 'Nifty Auto', label: 'Nifty Auto' },
    { key:3, value: 'NSE-ALL', label: 'Nifty All' },
    { key:4, value: 'Nifty Bank', label: 'Bank Nifty' },
    { key:5, value: 'Nifty 50', label: 'Nifty 50' },
    { key:6, value: 'Nifty Energy', label: 'Nifty Energy' },
    { key:7, value: 'Nifty 100', label: 'Nifty 100' },
    { key:8, value: 'Nifty Financial Serv', label: 'Nifty FinServ' },
    { key:9, value: 'Nifty 200', label: 'Nifty 200' },
    { key:10, value: 'Nifty FMCG', label: 'Nifty FMCG' },
    { key:11, value: 'Nifty 500', label: 'Nifty 500' },
    { key:12, value: 'Nifty Infrastructure', label: 'Nifty Infra' },
    { key:13, value: 'Nifty Midcap 50', label: 'Nifty MidCap 50' },
    { key:14,  value: 'Nifty IT', label: 'Nifty IT' },
    { key:15, value: 'Nifty Smallcap 100', label: 'Nifty SmallCap' },
    { key:16, value: 'Nifty Media', label: 'Nifty Media' },
    // { key:17, value: 'Nifty Junior', label: 'Nifty Junior' },
    { key:18, value: 'Nifty Metal', label: 'Nifty Metal' },
    { key:19, value: 'CNX-GOLD-ETF', label: 'Nifty Gold' },
    { key:20, value: 'Nifty MNC', label: 'Nifty MNC' },
    { key:21, value: 'IPO', label: 'Nifty IPO' },
    { key:22, value: 'Nifty Pharma', label: 'Nifty Pharma' },
    { key:23, value: 'CNX-ETF', label: 'Nifty ETF' },
    { key:24, value: 'Nifty PSE', label: 'Nifty PSE' },
    { key:25, value: 'Broad Market Indices', label: 'Major Indices' },
    { key:26, value: 'Nifty PSU Bank', label: 'Nifty PSU Bank' },
    { key:27, value: 'Thematic Indices', label: 'Thematic Indices' },
    { key:28, value: 'Nifty Realty', label: 'Nifty Realty' },
    { key:29, value: 'Nifty Services Sector', label: 'Nifty Service' },
];

export const MARKET_DASHBOARD_DAYS = [
    { key:1, value: '1-Day', label: '1-Day' },
    { key:2, value: '5-Day', label: '5-Day' },
    { key:3, value: '3-Month', label: '3-Month' },
    { key:4, value: '6-Month', label: '6-Month' },
    { key:5, value: '1-Year', label: '1-Year' },
    { key:6, value: '3-Year', label: '3-Year' },
    { key:7, value: '5-Year', label: '5-Year' },
    // { key:8, value: '7-YR', label: '7-Year' },
    { key:8, value: 'YTD', label: 'YTD', tooltipContent: 'Year to Date' },
    { key:9, value: 'MTD', label: 'MTD', tooltipContent: 'Month to Date' },
]

export const PATTERN_RECOGNITION_DAILY_PATTERNS = [
    { key:1, value: 'PR', label: 'Positive Reversal' },
    { key:2, value: 'NR', label: 'Negative Reversal' },
    { key:3, value: 'GOLDEN', label: 'Golden Cross' },
    { key:4, value: 'DEATH', label: 'Death Cross' },
    { key:5, value: 'GU', label: 'Gap-Ups' },
    { key:6, value: 'GD', label: 'Gap-Downs' },
    { key:7, value: '52WH', label: '52-Week Highs' },
    { key:8, value: '52WL', label: '52-Week Lows' },
    { key:9, value: 'INSIDE_DAY', label: 'Inside day' },
    { key:10, value: 'OUTSIDE_DAY', label: 'Outside day' },
    { key:11, value: '50MAVGP', label: '50-MA + 5% Range' },
    { key:12, value: '50MAVGN', label: '50-MA - 5% Range' },
    { key:13, value: '200MAVGP', label: '200-MA + 5% Range' },
    { key:14, value: '200MAVGN', label: '200-MA - 5% Range' },
];

export const PATTERN_RECOGNITION_WEEKLY_PATTERNS = [
    { key:15, value: '3WTP', label: '3-Week Tight Pattern' },
    { key:16, value: '5WTP', label: '5-Week Tight Pattern' },
    { key:17, value: 'UP5W', label: 'Up 5 Successive Weeks' },
];

export const PATTERN_RECOGNITION_ADMIN_PATTERNS = [
    { key:18, value: '52WVH', label: '52-Week Volume High' },
    { key:19, value: 'PERFECT_ALIGNMENT', label: 'Perfect Alignment' },
    { key:20, value: 'PERFECT_ALIGNMENT_NEW', label: 'Perfect Alignment New' },
    { key:21, value: 'PERFECT_ALIGNMENT_INVERSE', label: 'Perfect Alignment Inverse' },
    { key:22, value: 'INSIDE_DAY_POSITIVE_REVERSAL', label: 'Positive Reversal + Inside Day' },
    { key:23, value: 'INSIDE_DAY_NEGATIVE_REVERSAL', label: 'Negative Reversal + Inside Day' },
]

export const PATTERN_RECOGNITION_COLUMNS = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'SYMBOL', headerName: 'Stock Symbol', width: 170 },
    { field: 'INDEX_SECTOR_CODE', headerName: 'Index Sector', width: 170 },
    { field: 'CLOSE_VALUE', headerName: 'Latest Close Value', type: 'number', width: 150, align: 'center' },
    { field: 'VOLUME', headerName: 'Volume', type: 'number', width: 130 },
    { field: 'AVG_VOLUME_50_DAY', headerName: '50 Day Avg. Volume', type: 'number', width: 150, align: 'center' },
];

export const INDEXES_SYMBOL_COULMN = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'item', headerName: 'Stock Symbol', width: 170, editable: true },
]

export const PATTERN_RECOGNITION_VISIBLE_COLUMNS = ['SYMBOL', 'INDEX_SECTOR_CODE', 'CLOSE_VALUE', 'VOLUME', 'AVG_VOLUME_50_DAY'];

export const ADMIN_USERS = ['parvesh_sharma@hotmail.com', 'saurabh.gaur01@gmail.com', 'mageshgkumar@gmail.com'];

export const DEV_ADMIN_USERS = ['saurabh.gaur01@gmail.com', 'parvesh_sharma@hotmail.com', 'tradewithparvesh@gmail.com', 'surendersinghsharma@yahoo.co.in'];

export const SUPER_ADMIN = ['parvesh_sharma@hotmail.com', 'saurabh.gaur01@gmail.com'];

export const COLOR_BAR_CODE = ["#208ec9", "#c120c9", "#539412", "#f09d0e", "#b3a792", "#4b3c4d", "#db2923", "#e6b5dc"];